import { useEffect } from 'react';
import { navigate } from '@gatsbyjs/reach-router';
import { isRestrictedBooking } from '../utils/bookingRestrictions';
import { setSessionStorageItem } from '../operations/sessionStorage/utils';
import { NAVIGATION_PATHS, SESSION_STORAGE_RESTRICTED_BOOKING_REDIRECT } from '../utils/constants';

/**
 *
 * @param {object} booking - Booking object with `type` and `country.code`
 *   (e.g. currentBooking, or retrieveBooking.booking).
 * @param {object} ldFlags - LaunchDarkly flags object (data.ldFlags).
 * @returns {boolean} Whether the current booking is restricted in this market.
 */
const useRestrictedBookingGuard = (booking, ldFlags) => {
  const isRestricted = isRestrictedBooking(booking, ldFlags);

  useEffect(() => {
    if (isRestricted) {
      setSessionStorageItem(SESSION_STORAGE_RESTRICTED_BOOKING_REDIRECT, booking?.type);
      navigate(NAVIGATION_PATHS.bookFlights);
    }
  }, [isRestricted]);

  return isRestricted;
};

export default useRestrictedBookingGuard;
